// Credits pill — compact balance indicator that lives in the top bar.
// Click → opens the top-up modal (which lazy-loads Razorpay).
//
// Color logic:
//   balance >= 200              : muted (all good)
//   balance <  200 && >= 15     : amber (one chat left)
//   balance <  15               : red   (blocked)

import React, { useEffect } from 'react';
import { Coins, Plus } from 'lucide-react';
import { useCreditsStore } from '../../state/creditsStore';
import { useAuthStore } from '../../state/authStore';
import TopupModal from './TopupModal';

export default function CreditsPill() {
  const user = useAuthStore((s) => s.user);
  const { balance, refresh, openTopup } = useCreditsStore();

  // eslint-disable-next-line
  useEffect(() => { if (user) refresh(); }, [user]);

  if (!user) return null;
  if (balance === null) return null;

  const tone =
    balance < 15 ? 'text-red-500 bg-red-500/10 border-red-500/30'
      : balance < 200 ? 'text-amber-600 bg-amber-500/10 border-amber-500/30'
        : 'text-emerald-600 bg-emerald-500/10 border-emerald-500/30';

  const formatted = balance.toLocaleString();

  return (
    <>
      <button
        onClick={() => openTopup()}
        className={`hidden md:flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-[12px] font-semibold transition hover:brightness-110 ${tone}`}
        title={`${formatted} credits — click to top up`}
      >
        <Coins className="w-3.5 h-3.5" />
        <span>{formatted}</span>
        <Plus className="w-3 h-3 opacity-60" />
      </button>
      <TopupModal />
    </>
  );
}
